module.exports = __webpack_public_path__ + "img/lk-menu-arrow.c61b61bc.svg";